import React from 'react';
import { StyledRowQuotes } from './StyledRowQuotes';

const RowQuotes = ({ quote, name, company, position, img, isLanding}) => {
  return (
    <React.Fragment>
      {
        <StyledRowQuotes>
          {
            img &&
            <div className="avatar">
              <img src={img} />
            </div>
          }
          {
            isLanding &&
            <p className="preset-10 quote--name">{name}</p>
          }
          <p className="preset-10">{quote}</p>
          {
            !isLanding &&
            <p className="preset-10 quote--name">{name}</p>
          }
          <p className="preset-9 quote--company">
            <span>{company} </span> 
            {position}
          </p>
        </StyledRowQuotes>
      }
    </React.Fragment>
  );
};

export default RowQuotes;
